export const DataViewerStyles = () => {
  return {
    "& .board-builder": {
        display: "flex",
        flexWrap: "wrap",
      "& > .MuiGrid-container": {
        md: {
          justifyContent: "space-between",
          width: "calc(100% - 164px)",
        },
      },
      "& > .MuiGrid-container > .MuiGrid-item:nth-of-type(1)": {
        md: {
          flexBasis: "auto",
          width: "120px",
        },
      },
      "& > .MuiGrid-container > .MuiGrid-item:nth-of-type(2), & > .MuiGrid-container > .MuiGrid-item:nth-of-type(3)": {
        md: {
          flexBasis: "auto",
          width: "40%",
        },
      },
      "& .actions": {
        md:{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          width: "164px",
        }
      },
      "& .actions button[type='submit']": {
        md: {
          marginTop: "0",
        }
      }
    }
  }
}
